var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper",
    class: [_vm.customClass]
  }, [_vm._t("default"), _vm._v(" "), (_vm.designer.selectedId === _vm.widget.id && !_vm.widget.internal) ? _c('div', {
    staticClass: "container-action"
  }, [_c('i', {
    staticClass: "el-icon-back",
    attrs: {
      "title": _vm.i18nt('designer.hint.selectParentWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectParentWidget(_vm.widget)
      }
    }
  }), _vm._v(" "), (!!_vm.parentList && (_vm.parentList.length > 1)) ? _c('i', {
    staticClass: "el-icon-top",
    attrs: {
      "title": _vm.i18nt('designer.hint.moveUpWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.moveUpWidget()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!!_vm.parentList && (_vm.parentList.length > 1)) ? _c('i', {
    staticClass: "el-icon-bottom",
    attrs: {
      "title": _vm.i18nt('designer.hint.moveDownWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.moveDownWidget()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.widget.type === 'table') ? _c('i', {
    staticClass: "iconfont icon-insertrow",
    attrs: {
      "title": _vm.i18nt('designer.hint.insertRow')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.appendTableRow(_vm.widget)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.widget.type === 'table') ? _c('i', {
    staticClass: "iconfont icon-insertcolumn",
    attrs: {
      "title": _vm.i18nt('designer.hint.insertColumn')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.appendTableCol(_vm.widget)
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.widget.type === 'grid') || (_vm.widget.type === 'table')) ? _c('i', {
    staticClass: "el-icon-copy-document",
    attrs: {
      "title": _vm.i18nt('designer.hint.cloneWidget')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cloneContainer(_vm.widget)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-delete",
    attrs: {
      "title": _vm.i18nt('designer.hint.remove')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeWidget.apply(null, arguments)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.designer.selectedId === _vm.widget.id && !_vm.widget.internal) ? _c('div', {
    staticClass: "drag-handler"
  }, [_c('i', {
    staticClass: "el-icon-rank",
    attrs: {
      "title": _vm.i18nt('designer.hint.dragHandler')
    }
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.i18n2t(("designer.widgetLabel." + (_vm.widget.type)), ("extension.widgetLabel." + (_vm.widget.type)))))]), _vm._v(" "), (_vm.widget.options.hidden === true) ? _c('i', {
    staticClass: "iconfont icon-hide"
  }) : _vm._e()]) : _vm._e()], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63719d5c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/container-widget/container-wrapper.vue
// module id = null
// module chunks = 